export enum ReportGrouping {
  BY_SINGLE_DIMENSION = 'BY_SINGLE_DIMENSION',
  COMBINED = 'COMBINED',
  COMBINED_AND_BY_SINGLE_DIMENSION = 'COMBINED_AND_BY_SINGLE_DIMENSION',
}
